export class TestActiveCode {
    code!: string
    expiredAt!: string
    expiredAtPretty!: string
}